import PortfolioWebsite from "../../../../assets/Portfolio.webp";
import PortfolioWebsiteLazy from "../../../../assets/PortfolioLazy.webp";
import YoutubeClone from "../../../../assets/YoutubeClone.webp";
import YoutubeCloneLazy from "../../../../assets/YoutubeCloneLazy.webp";
import CrownCloths from "../../../../assets/Crow-Clothes.webp";
import CrownClothsLazy from "../../../../assets/Crow-ClothesLazy.webp";
import MovieApp from "../../../../assets/Movie-App.webp";
import MovieAppLazy from "../../../../assets/Movie-AppLazy.webp";
import JsECommerce from "../../../../assets/JsE-CommerceApp.webp";
import JsECommerceLazy from "../../../../assets/JsE-CommerceAppLazy.webp";
import Forkfiy from "../../../../assets/forkify.webp";
import ForkfiyLazy from "../../../../assets/forkifyLazy.webp";
import Mapty from "../../../../assets/mapty.webp";
import MaptyLazy from "../../../../assets/maptyLazy.webp";
import IDemy from "../../../../assets/idemy.webp";
import IDemyLazy from "../../../../assets/idemyLazy.webp";
import Planteo from "../../../../assets/planteo.webp";
import PlanteoLazy from "../../../../assets/planteoLazy.webp";
import Bruno from "../../../../assets/BrunoSimmons.webp";
import BrunoLazy from "../../../../assets/BrunoSimmonsLazy.webp";
import TimeZone from "../../../../assets/timezone.webp";
import TimeZoneLazy from "../../../../assets/timezoneLazy.webp";
import Anime from "../../../../assets/Anime.webp";
import AnimeLazy from "../../../../assets/AnimeLazy.webp";
import Bakery from "../../../../assets/Bakery.webp";
import BakeryLazy from "../../../../assets/BakeryLazy.webp";
export const PROJECTS__DATA = [
	{
		id: "pd-3",
		name: "Movie App",
		image__Src: MovieApp,
		lazyImage__Src: MovieAppLazy,
		livePreview__Url: "https://movie-app-six-xi.vercel.app/",
		github__Url: "https://github.com/AbdulrahmanAshraf98/movie-app",
		video__Url:
			"https://www.youtube.com/watch?v=kjDcGwcrmCQ&t=106s&ab_channel=AbdulrahmanAshraf",

		technologies: [
			"React JS",
			"Firebase",
			"Tmdb-Api",
			"React Redux",
			"Redux-Thunk",
			"React-Context Api",
			"React-Router-Dom",
		],
		categories: ["React Js"],
	},
	{
		id: "PR-1",
		name: "Personal Portfolio",
		image__Src: PortfolioWebsite,
		lazyImage__Src: PortfolioWebsiteLazy,
		livePreview__Url: "https://portfolio-mauve-gamma-79.vercel.app/",
		github__Url: "https://github.com/AbdulrahmanAshraf98/Portfolio",
		video__Url:
			"https://drive.google.com/file/d/1S8GMcAl5Jb5PlgZRZzo_2AhSrTZ5hVbf/view?usp=sharing",

		technologies: ["React JS", "Tailwind Css", "PWA"],
		categories: ["React Js", "Tailwind Css"],
	},
	{
		id: "pd-1",
		name: "Youtube-Clone",
		image__Src: YoutubeClone,
		lazyImage__Src: YoutubeCloneLazy,
		livePreview__Url: "https://youtube-clone-react-mu.vercel.app/",
		github__Url:
			"https://github.com/AbdulrahmanAshraf98/Youtube-Clone-React-MU",
		video__Url:
			"https://drive.google.com/file/d/1GDlJdNgYhuiL3MZpk_jp5g_5ToB2B1RH/view",

		technologies: [
			"React JS",
			"React-Redux",
			"Redux-Thunk",
			"Material Ui",
			"Youtube-Api",
			"React-Router-Dom",
		],
		categories: ["React Js"],
	},
	{
		id: "pd-2",
		name: "Crow Cloths E-Commerce",
		image__Src: CrownCloths,
		lazyImage__Src: CrownClothsLazy,
		livePreview__Url: "https://crown-clothes.vercel.app/",
		github__Url: "https://github.com/AbdulrahmanAshraf98/Crown-Clothes",
		video__Url:
			"https://drive.google.com/file/d/1nG28kYjyL8BwyHrzmOFoPrwWvHQqxJKF/view",

		technologies: [
			"React JS",
			"Firebase",
			"Stripe",
			"React-Redux",
			"Redux-Thunk",
			"React-Router-Dom",
			"Styled-Components",
		],
		categories: ["React Js"],
	},

	{
		id: "js-5",
		name: "E-Commerce Js",
		image__Src: JsECommerce,
		lazyImage__Src: JsECommerceLazy,
		livePreview__Url: "https://e-commerce-vanlia-javascript.vercel.app/",
		github__Url:
			"https://github.com/AbdulrahmanAshraf98/e-commerce-Vanlia-Javascript-Tailwind-Css-Wepback",
		video__Url:
			"https://drive.google.com/file/d/1lJdqdGk5lJqycDtqaua9nEWRUo6IZLeb/view?usp=sharing",

		technologies: ["Js", "Tailwind Css", "Api"],
		categories: ["Js", "Tailwind Css"],
	},
	{
		id: "pd-4",
		name: "Forkify Recipe Website",
		image__Src: Forkfiy,
		lazyImage__Src: ForkfiyLazy,
		livePreview__Url: "https://forkify-project-two.vercel.app/",
		github__Url: "https://github.com/AbdulrahmanAshraf98/forkifyProject",
		video__Url:
			"https://drive.google.com/file/d/1MStBVkjJvgcPFMBAZnm3l_WG_neYYLp1/view",

		technologies: ["Js", "Sass", "Api"],
		categories: ["Js"],
	},
	{
		id: "pd-m4",
		name: "Mapty",
		image__Src: Mapty,
		lazyImage__Src: MaptyLazy,
		livePreview__Url: "https://mapty-app-seven.vercel.app/",
		github__Url: "https://github.com/AbdulrahmanAshraf98/MaptyApp",
		video__Url:
			"https://drive.google.com/file/d/1jH7rFoVzp4GaIb_xNj7dvgnHCIux568X/view?usp=sharing",

		technologies: ["Js", "Api"],
		categories: ["Js"],
	},
	{
		id: "pd-5",
		name: "Idemy",
		image__Src: IDemy,
		lazyImage__Src: IDemyLazy,
		livePreview__Url: "https://i-demy-template.vercel.app/index.html",
		github__Url: "https://github.com/AbdulrahmanAshraf98/iDemy-Template",
		video__Url:
			"https://drive.google.com/file/d/13P6cntYYmDB3I3Yq-3G_GXp58xTUOlNh/view",

		technologies: ["Bootstrap4", "Jquery", "Html5", "Css3"],
		categories: ["Bootstrap", "Jquery"],
	},
	{
		id: "pd-6",
		name: "Planteo",
		image__Src: Planteo,
		lazyImage__Src: PlanteoLazy,
		livePreview__Url: "https://abdulrahmanashraf98.github.io/planteo-template/",
		github__Url: "https://github.com/AbdulrahmanAshraf98/planteo-template",
		video__Url:
			"https://drive.google.com/file/d/1vnBJxeC7AKfTBpZ2S2WUNsx-YMlMmWvq/view",

		technologies: ["Bootstrap4", "Jquery", "Html5", "Css3"],
		categories: ["Bootstrap", "Jquery"],
	},
	{
		id: "pd-7",
		name: "Bruno Simmons",
		image__Src: Bruno,
		lazyImage__Src: BrunoLazy,
		livePreview__Url: "https://html-css-java-script.vercel.app/",
		github__Url:
			"https://github.com/AbdulrahmanAshraf98/convert-Figma-to-html-and-css-",
		video__Url:
			"https://drive.google.com/file/d/1x1eJ6vxCKN3mRQa_zM1SLEbIHhVEP9yb/view",

		technologies: ["Html5", "Css3", "Figma"],
		categories: ["Html-Css"],
	},
	{
		id: "pd-8",
		name: "TimeZone",
		image__Src: TimeZone,
		lazyImage__Src: TimeZoneLazy,
		livePreview__Url: "https://template-four.vercel.app/",
		github__Url: "https://github.com/AbdulrahmanAshraf98/template-four",
		video__Url:
			"https://drive.google.com/file/d/1odZQnTPg_mECg8wqYS3arTODXZHc-ljI/view?usp=sharing ",

		technologies: ["Html5", "Css3"],
		categories: ["Html-Css"],
	},
	{
		id: "pd-9",
		name: "Anime ",
		image__Src: Anime,
		lazyImage__Src: AnimeLazy,
		livePreview__Url: "https://template-6.vercel.app/",
		github__Url: "https://template-6.vercel.app/",
		video__Url:
			"https://drive.google.com/file/d/1U3CMvpTI9doMK_bbJV-eopiErUATx4nn/view",

		technologies: ["Html5", "Css3"],
		categories: ["Html-Css"],
	},
	{
		id: "pd-10",
		name: "Bakery",
		image__Src: Bakery,
		lazyImage__Src: BakeryLazy,
		livePreview__Url: "https://template-three-chi.vercel.app/",
		github__Url: "https://github.com/AbdulrahmanAshraf98/template-three",
		video__Url:
			"https://drive.google.com/file/d/1elOt7oM8hedZFeTECi2bjXf_yqMWUaVY/view",

		technologies: ["Html5", "Css3"],
		categories: ["Html-Css"],
	},
];
